import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, Footer, FooterProps, withTheme } from '@gn-audio/jss-components';
import { tailwindConfig } from '@gn-audio/jss-components/tailwind-presets';

export default withTheme({
  defaultTheme: {
    darkTheme: false,
    backgroundColor: tailwindConfig.theme.colors.beige['100'],
  },
})(withDatasourceCheck()<ComponentProps & FooterProps>(Footer));
